import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { defaultOptions, INbSelectItem, INbSelectOptions } from '@app/common/basic/models/nb-select';
import { NbValueAccessor } from '@app/common/basic/models/nb-value-accessor';
import { Observable } from 'rxjs';

@Component({
  selector: 'nb-select',
  templateUrl: './nb-select.component.html',
  styleUrls: ['./nb-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbSelectComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbSelectComponent<T = INbSelectItem> extends NbValueAccessor<T> implements OnInit {
  @Input()
  data: T[] | Observable<T[]>;

  @Input()
  options: INbSelectOptions;

  @Output()
  change = new EventEmitter<T>();

  innerOptions: INbSelectOptions;

  setModel(item: T) {
    this.writeValue(item);
    this.change.emit(item);
  }

  ngOnInit() {
    this.innerOptions = { ...defaultOptions, ...this.options };
  }
}
